/* tslint:disable */

import $ from "jquery";

export function handleResizeJQuery(portletInstanceId: number): void {

	// let theDate = new Date();
	// console.log("resizing portletInstanceId " + portletInstanceId.toString() + " [" + theDate.getTime() + "]");

	const calendarSelector = "#portlet" + portletInstanceId + ".PO-calendar";

	$(calendarSelector).each(function () {
		var portletWidth = $(this).width();

		if (portletWidth < 740) {
			$(this).addClass('CAL-under740');
		}
		else {
			$(this).removeClass('CAL-under740');
		}

		if (portletWidth < 725) {
			$(this).addClass('CAL-under725');
		}
		else {
			$(this).removeClass('CAL-under725');
		}

		if (portletWidth < 500) {
			$(this).addClass('CAL-under500');
		}
		else {
			$(this).removeClass('CAL-under500');
		}

		if (portletWidth < 300) {
			$(this).addClass('CAL-under300');
		}
		else {
			$(this).removeClass('CAL-under300');
		}
	});

	if ($(calendarSelector).is('.CAL-V-MV-mob, .CAL-V-WV')) {

		$('.CAL-V-MV-events').each(function () { // Does this need a (this)?

			// Show or hide the '+N' links:
			var eventItems = $(this).find('.CAL-EV-Item:visible').not('.CAL-EV-plus').length;
			var numHiddenEvents = $(this).find('.CAL-EV-Item:hidden').not('.CAL-EV-plus').length;

			if (numHiddenEvents && numHiddenEvents > 0) {
				$(this).find('.CAL-EV-plus').show();
				$(this).find('.CAL-EV-plus a').text("+" + (numHiddenEvents));
			}
			else {
				$(this).find('.CAL-EV-plus').hide();
			}

			// Set the widths of the event bars:
			var itemWidth = (100 / eventItems);
			var takeOffItem = (45 / eventItems);

			if ($(this).find('.CAL-EV-plus').is(":visible")) {
				$(this).find('.CAL-EV-Item').not('.CAL-EV-plus').css('width', itemWidth + '%').css('width', '-=' + takeOffItem + 'px');
			}
			else {
				$(this).find('.CAL-EV-Item').not('.CAL-EV-plus').css('width', itemWidth + '%');
			}
		});

	} else {
		$(this).find('.CAL-EV-plus').css('visibility', 'visible');
	}

}

export function setUpCustomScrollbarJQuery(portletInstanceId: number) {

	// let theDate = new Date();
	// console.log("adding scrollbar to portletInstanceId " + portletInstanceId.toString() + " [" + theDate.getTime() + "]");

	const calendarSelector = "#portlet" + portletInstanceId + ".PO-calendar";

	if ($(calendarSelector + " .CAL-scroll-wrapper").length) {
		$(calendarSelector + " .CAL-scroll-wrapper").mCustomScrollbar({
			scrollButtons: {
				enable: true
			},
			theme: "dark-thick",
			scrollInertia: 100,
		});
	}

	// Set tabIndex on the scrollable DIV to -1 so it gets skipped in tab order.
	if ($(calendarSelector + " .mCustomScrollBox").length) {
		$(calendarSelector + " .mCustomScrollBox").attr("tabindex", "-1");
	}

}

export function scrollToSelectedDate(portletInstanceId: number) {

	const calendarSelector = "#portlet" + portletInstanceId + ".PO-calendar";
	const dateAnchorSelector = "a.CAL-V-MV-SD-selected";

	scrollToElement(calendarSelector, dateAnchorSelector);
}

export function scrollToTabbedDate(portletInstanceId: number, event: any) {

	const calendarSelector = "#portlet" + portletInstanceId + ".PO-calendar";

	const cellDate = event.currentTarget.attributes["data-date-short"].value;
	const tabbedDateAnchorSelector = "a.CAL-V-MV-selectDay.cell" + cellDate;

	scrollToElement(calendarSelector, tabbedDateAnchorSelector);

}

function scrollToElement(calendarSelector: string, elementSelector: string) {

	const dateAnchorSelector = $(calendarSelector + " " + elementSelector).parent();

	if (dateAnchorSelector.offset()) {

		// let theDate = new Date();
		// console.log("scrolling to element on portletInstanceId " + portletInstanceId.toString() + " [" + theDate.getTime() + "]");

		let currentDayTop = (dateAnchorSelector.offset().top - dateAnchorSelector.parent().offset().top - 147);

		const dateAnchorHeight = dateAnchorSelector.height();
		const dateAnchorParentHeight = dateAnchorSelector.parent().height();

		const maxAllowedScroll = dateAnchorParentHeight - dateAnchorHeight - (2 * 147); // Have to allow for not overscrolling at bottom of list.

		currentDayTop = Math.max(0, currentDayTop); // Scroll position can't be less than zero.
		currentDayTop = Math.min(maxAllowedScroll, currentDayTop); // Scroll position can't be more than the height of the UL minus the height of the selected LI.

		$(calendarSelector + ' .CAL-scroll-wrapper.mCustomScrollbar .mCSB_container').css({
			top: '-' + currentDayTop + 'px'
		});
	}
}
